module.exports = __webpack_public_path__ + "static/media/fractal.1d95fa62.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/fractal.png
// module id = 50
// module chunks = 0